// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WarehouseModal_modalOverlay__Xd41p {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.WarehouseModal_modalContainer__4w80w {
  text-align: left;
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 400px;
  max-height: 500px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.WarehouseModal_modalContainer__4w80w h2 {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 20px;
}

.WarehouseModal_scrollArea__0mwwy {
  overflow-y: auto;
  max-height: 300px;
  margin: 10px 0;
}

.WarehouseModal_modalButtons__BlLQm {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}


.WarehouseModal_list__R9oG9 {
  list-style: none;
  padding: 0;
  margin: 0;
}

.WarehouseModal_item__AydBO {
  margin-bottom: 18px;
}

.WarehouseModal_radioLabel__V4BeB {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.WarehouseModal_radioLabel__V4BeB input {
  display: none;
}

.WarehouseModal_customRadio__tpq8y {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(29, 135, 82, 1);
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
}

.WarehouseModal_radioLabel__V4BeB input:checked + .WarehouseModal_customRadio__tpq8y::after {
  content: '';
  width: 10px;
  height: 10px;
  background: rgba(29, 135, 82, 1);
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
}

.WarehouseModal_cancel__reCPK,
.WarehouseModal_add__4UVUU {
    background: rgba(29, 135, 82, 1);
    padding: 10px 20px;
    border-radius: 4px;
    color: white;
}

.WarehouseModal_cancel__reCPK {
    background: none;
    border: 1px solid gray;
    color: gray;
}`, "",{"version":3,"sources":["webpack://./src/pages/tables/customComponentsTable/WarehouseModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;;AAGA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;;IAEI,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;AACf","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modalContainer {\n  text-align: left;\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  width: 400px;\n  max-height: 500px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.modalContainer h2 {\n    font-weight: bold;\n    font-size: 18px;\n    margin-bottom: 20px;\n}\n\n.scrollArea {\n  overflow-y: auto;\n  max-height: 300px;\n  margin: 10px 0;\n}\n\n.modalButtons {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n\n.list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.item {\n  margin-bottom: 18px;\n}\n\n.radioLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.radioLabel input {\n  display: none;\n}\n\n.customRadio {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(29, 135, 82, 1);\n  border-radius: 50%;\n  margin-right: 10px;\n  position: relative;\n}\n\n.radioLabel input:checked + .customRadio::after {\n  content: '';\n  width: 10px;\n  height: 10px;\n  background: rgba(29, 135, 82, 1);\n  border-radius: 50%;\n  position: absolute;\n  top: 3px;\n  left: 3px;\n}\n\n.cancel,\n.add {\n    background: rgba(29, 135, 82, 1);\n    padding: 10px 20px;\n    border-radius: 4px;\n    color: white;\n}\n\n.cancel {\n    background: none;\n    border: 1px solid gray;\n    color: gray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `WarehouseModal_modalOverlay__Xd41p`,
	"modalContainer": `WarehouseModal_modalContainer__4w80w`,
	"scrollArea": `WarehouseModal_scrollArea__0mwwy`,
	"modalButtons": `WarehouseModal_modalButtons__BlLQm`,
	"list": `WarehouseModal_list__R9oG9`,
	"item": `WarehouseModal_item__AydBO`,
	"radioLabel": `WarehouseModal_radioLabel__V4BeB`,
	"customRadio": `WarehouseModal_customRadio__tpq8y`,
	"cancel": `WarehouseModal_cancel__reCPK`,
	"add": `WarehouseModal_add__4UVUU`
};
export default ___CSS_LOADER_EXPORT___;
